export default __webpack_public_path__ + "static/media/popup_side_img.feb8589e.svg";